import { ShieldCheck } from 'lucide-react';

import { PageHeader } from '../../../components/shared';
import { useActionPermission } from '../../../hooks/usePermission';
import { useT } from '../../../i18n';
import { useAuthStore } from '../../../stores/auth';
import { useTenantCuaToi } from '../../auth/hooks/useTenantCuaToi';
import { VAI_TRO_QUAN_TRI_TENANT } from '../../auth/nghiep-vu/quyen-cong-tenant';
import { KhongCoTenant } from '../../nhat-ky/components/KhongCoTenant';
import { CaiDatBaoMat } from '../components/CaiDatBaoMat';

/**
 * "Cài đặt bảo mật" của cổng tenant — `/he-thong/bao-mat` (ADR-0059 mục 8).
 *
 * Nằm trong nhóm `CẤU HÌNH HỆ THỐNG` cạnh vai trò và người dùng: đó là chỗ
 * Tenant Admin đã quen quản trị tổ chức của mình. Màn chỉ là khung; toàn bộ
 * nội dung là `CaiDatBaoMat`, dùng chung với tab "Bảo mật" ở cổng nền tảng. Địa chỉ truy cập riêng (ADR-0097) có
 * màn riêng, `/he-thong/dia-chi-rieng`.
 */
export function CaiDatBaoMatView() {
  const { t } = useT();
  const { tenantId, dangTai } = useTenantCuaToi();
  /*
   * TODO(G2-D1-6): quyền ở cổng tenant tính từ `me/context` mới có `.READ`
   * (`tinhQuyenCongTenant`). Cài đặt bảo mật chỉ quản trị tổ chức mở được
   * (`cau-hinh-he-thong`, ADR-0059 mục 8), nên role lớp 1 `TENANT_ADMIN` là
   * quyền sửa cho tới khi có bảng hành động ghi. Backend vẫn kiểm.
   */
  const laQuanTriToChuc = useAuthStore(
    (s) => s.user?.vaiTroLop1?.includes(VAI_TRO_QUAN_TRI_TENANT) ?? false,
  );
  const duocSua = useActionPermission('SECURITY_CONFIG', 'UPDATE') || laQuanTriToChuc;

  return (
    <div className="flex h-full flex-col bg-subtle">
      <div className="flex-1 space-y-4 overflow-y-auto p-4 pb-12">
        <PageHeader
          breadcrumb={[{ label: t('nav.nhom.cauHinhHeThong') }, { label: t('nav.muc.caiDatBaoMat') }]}
          titleIcon={<ShieldCheck size={18} className="text-primary-600" />}
          title={t('nav.muc.caiDatBaoMat')}
        />
        {tenantId ? (
          <CaiDatBaoMat tenantId={tenantId} laNenTang={false} duocSua={duocSua} />
        ) : dangTai ? null : (
          <KhongCoTenant />
        )}
      </div>
    </div>
  );
}
